import styled from 'styled-components';

/**
 * The design's `.segmented`.
 *
 * The two literals here are the design file's own and there is no token for
 * either: `2px` is the track that shows around the lifted segment, and the
 * segment's radius is one notch inside `--r-sm` — using `--r-sm` for both
 * would draw a rounded box inside an equally rounded box. The same reasoning
 * that left `.status i` at 6px and the empty-state icon at 44px applies.
 *
 * The height is not the design's `5px 12px` padding: `--h-btn-sm` inside a
 * 2px track and a 1px border comes to exactly `--h-btn`, so the control lines
 * up with the search box and the Filters button standing next to it in the
 * toolbar.
 */
export const Segmented = styled.div`
  display: flex;
  gap: 2px;
  padding: 2px;
  background: var(--surface-alt);
  border: 1px solid var(--line);
  border-radius: var(--r-sm);
`;

export const Segment = styled.button`
  height: var(--h-btn-sm);
  padding: 0 var(--s3);
  border: none;
  border-radius: 4px;
  background: none;
  font-family: var(--font-ui);
  font-size: var(--fs-label);
  font-weight: var(--fw-medium);
  line-height: var(--lh-body);
  white-space: nowrap;
  color: var(--text-muted);
  cursor: pointer;
  transition:
    background-color 0.12s,
    color 0.12s;

  &:hover {
    color: var(--text);
  }

  &.on {
    background: var(--surface);
    box-shadow: var(--sh-1);
    font-weight: var(--fw-semibold);
    color: var(--text);
  }
`;
